import {
    ADD_SPECIALIST,
    CHANGE_PROGRESS,
    DELETE_CLIENT,
    DELETE_CLIENT_SPECIALIST,
    FULLFILL_CLIENT,
    FULLFILL_CLIENTS,
    FULLFILL_SPECIALIST,
    RESET_VALIDATION_ERRORS_BY_FIELD,
    SET_VALIDATION_ERRORS
} from './available'

import _ from 'lodash'

export default {
    [FULLFILL_CLIENTS](state, clients) {
        state.clients = clients
    },
    [FULLFILL_CLIENT](state, client) {
        let index = _.findIndex(state.clients, function (item) {
            return item.id === client.id
        })

        if (index < 0) {
            return
        }

        state.clients.splice(index, 1, client)
    },
    [DELETE_CLIENT](state, clientData) {
        let index = _.findIndex(state.clients, function (item) {
            return item.id === clientData.id
        })

        if (index < 0) {
            return
        }

        state.clients.splice(index, 1)
    },
    [FULLFILL_SPECIALIST](state, specialist) {
        let clientIndex = _.findIndex(state.clients, function (item) {
            return item.id === specialist.clientId
        })

        if (clientIndex < 0) {
            return
        }

        let specialistIndex = _.findIndex(state.clients[clientIndex].specialists, function (item) {
            return item.id === specialist.id
        })

        if (specialistIndex < 0) {
            return
        }

        const client = _.cloneDeep(state.clients[clientIndex])

        client['specialists'][specialistIndex] = specialist

        state.clients.splice(clientIndex, 1, client)
    },
    [ADD_SPECIALIST](state, specialist) {
        let clientIndex = _.findIndex(state.clients, function (item) {
            return item.id === specialist.clientId
        })

        if (clientIndex < 0) {
            return
        }

        state.clients[clientIndex].specialists.push(specialist)
    },
    [DELETE_CLIENT_SPECIALIST](state, specialist) {
        let clientIndex = _.findIndex(state.clients, function (item) {
            return item.id === specialist.clientId
        })

        if (clientIndex < 0) {
            return
        }

        let specialistIndex = _.findIndex(state.clients[clientIndex].specialists, function (item) {
            return item.id === specialist.id
        })

        if (specialistIndex < 0) {
            return
        }

        state.clients[clientIndex].specialists.splice(specialistIndex, 1)
    },
    [CHANGE_PROGRESS](state, {context, value}) {
        state.progress[context] = value
    },
    [SET_VALIDATION_ERRORS](state, {context, value}) {
        state.errorMessagesByFields[context] = value
    },
    [RESET_VALIDATION_ERRORS_BY_FIELD](state, {context, fieldName}) {
        delete state.errorMessagesByFields[context][fieldName]
    },
}
